const SIDEBAR_COLLAPSED = "SIDEBAR_COLLAPSED";

export function setSidebarCollapsed(val) {
  localStorage.setItem(SIDEBAR_COLLAPSED, val);
}

export function getSidebarCollapsed() {
  return "true" === (localStorage.getItem(SIDEBAR_COLLAPSED) || "false");
}
